import { FaComment } from 'react-icons/fa';
import { useChat } from './ChatContext';

const ChatButton = () => {
  const { isOpen, setIsOpen, showNotification } = useChat();

  const handleClick = () => {
    setIsOpen(true);
  };

  if (isOpen) return null;

  return (
    <button
      className="chat-widget-button"
      onClick={handleClick}
      aria-label="Open chat"
    >
      <FaComment />
      {showNotification && (
        <div className="chat-notification">
          <span>Need help? Chat with me!</span>
        </div>
      )}
    </button>
  );
};

export default ChatButton;

